<template>
  <v-row>
    <v-col cols="12" class="text-right">
      <v-btn
        x-small
        elevation="10"
        class="text-xs font-weight-semibold"
        color="error"
        :to="{ name: 'savings.delete_client' }"
      >
        <font-awesome-icon
          icon="fa-solid fa-times"
          class="pe-1"
        />
        Delete Client To zone
      </v-btn>
    </v-col>
  <v-col cols="12">
  <div>
  <h3 class="primary darken-2 pa-2 white--text font-weight-bold">Add user to zone</h3>
  
  <v-card
  flat
  class="pa-3 mt-1"
>
      <v-select
      v-model="to_send.zone_name"
      :items="zones"
      item-text="name"
      item-value="spot_name"
      outlined dense
      label="Select a zone"
    ></v-select>

    <v-form @submit.prevent="save">
      <v-text-field
        v-model="search"
        label="Search for a user..."
        dense outlined
      />

    <div class="user-list">
      <label v-for="user in users" :key="user.id" class="user-item">
        <input type="checkbox" v-model="to_send.list_of_user" :value="user.id" />
        {{ user.username }}
      </label>
    </div>
    <v-btn
        type="submit"
        color="primary"
        class="mt-3"
        :disabled="$store.state.isLoading"
      >
        <template v-if="$store.state.isLoading">
          <v-progress-circular
            indeterminate
            size="20"
            color="white"
          ></v-progress-circular>
        </template>
        <template v-else>
          Send
        </template>
      </v-btn>
    </v-form>
    </v-card>
  </div>
  </v-col>
  </v-row>
  
  </template>
  
  <script>
  import axios from "axios";
  
  export default {
    data() {
      return {
        users: [], 
        zones:[],
        search: "", 
        to_send:{
            list_of_user:[],
            zone_name:"",
        }
      };
    },
    mounted() {
      this.fetchUsers();
      this.fetchZones();

    },
    watch: {
      search(val) {
        if (val.trim() === "") {
          this.fetchUsers();
        } else {
          this.fetchUsersSearch(val.trim());
        }
      }
    },

    methods: {
      onSearchInput() {
        if (this.search.trim() === "") {
          this.fetchUsers();
        } else {
          this.fetchUsersSearch(this.search.trim());
        }
      },
      resetForm() {
        this.to_send = {
          list_of_user: [],
          zone_name: "",
        };
        this.search = "";
        this.fetchUsers(); // recharge tous les utilisateurs
      },

      async fetchUsers() {
        try {
          const response = await axios.post("/api/v1/manager/all_user/");
          this.users = response.data;
          this.to_send.list_of_user = [];
        } catch (error) {
          if (error.response){
            this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
          }else{
            this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
          }
        }
      },
      async fetchZones(){
        try {
            const response = await axios.post("/api/v1/manager/all_zone/");
            this.zones = response.data;
        } catch (error) {
          if (error.response){
            this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
          }else{
            this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
          }
        }
      },
      async fetchUsersSearch(client) {
        try {
          const response = await axios.get(`/api/v1/manager/get/clients/${client}/`);
          this.users = response.data;
          this.to_send.list_of_user = [];
        } catch (error) {
          if (error.response){
            this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
          }else{
            this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
          }
        }
      },

      async save() {
      this.$store.commit("setIsLoading", true);
      try {
        const response = await axios.post("/api/v1/manager/insert_user_zone/", this.to_send);
          this.$store.commit("setSnackBarMessage", response.data.success);
          this.$store.commit("setSnackBarColor", "green");
          this.$store.commit("activateSnackBar", true);
          this.resetForm();
      } catch (error) {
        let errorMessage = "An error has occurred.";
            if (error.response && error.response.data.error) {
              errorMessage = error.response.data.error;
            }
            this.$store.commit("setSnackBarMessage", errorMessage);
            this.$store.commit("setSnackBarColor", "red");
            this.$store.commit("activateSnackBar", true);
      }

      this.$store.commit("setIsLoading", false);
    },
      submitSelection() {
        console.log("Users selected :", this.selectedUsers);
      },
    },
  };
  </script>
  
  <style scoped>
  .user-list-container {
    width: 300px;
    border: 1px solid #ddd;
    padding: 10px;
    border-radius: 5px;
    background: #f9f9f9;
  }
  
  .user-list {
    max-height: 150px; /* 5 utilisateurs visibles (~30px chacun) */
    overflow-y: auto;
    border: 1px solid #ccc;
    padding: 5px;
    background: white;
  }
  
  .user-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 5px;
  }
  </style>
  